module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (34).7eab1154.jpg";